module.exports = __webpack_public_path__ + "static/media/padaria.1a465ddd.svg";